import type { Web3DViewer } from '@technology/web3d';
import type { CapabilityRegistry } from '@trimble/web3d';

export type CapabilityPane = ReturnType<
  CapabilityRegistry['paneContainers']
>[0];

export interface PaneEligibilityOptions {
  isPaneEligible?(pane: CapabilityPane): boolean;
}

export function defaultPaneEligibility(pane: CapabilityPane): boolean {
  return pane.viewerWrapper()?.viewer !== undefined;
}

export function getEligibleViewers(
  registry: CapabilityRegistry,
  isPaneEligible: (pane: CapabilityPane) => boolean = defaultPaneEligibility
): Web3DViewer[] {
  return registry
    .paneContainers()
    .filter(isPaneEligible)
    .map((pane) => pane.viewerWrapper()?.viewer)
    .filter((viewer): viewer is Web3DViewer => viewer !== undefined);
}
